module.exports = __webpack_public_path__ + "img/Game_target_Z-10.1a508ac6.png";